<template>
  <div class="width100 margin-auto">
    <!-- 检索 -->
    <div class="backwhite">
      <div class="f16 width98 textalign-left dimensional">企业合同修改</div>
      <el-form ref="form" :model="form" class="pad-top30 pad-bot10">
        <el-form-item label="合同名称" class="width100">
          <el-input
            placeholder="请输入合同名称"
            v-model="form.title"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="签署时间" class="width100">
          <el-date-picker
            class="inputDeep"
            v-model="form.write_date"
            type="date"
            placeholder="请选择签署时间"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="电子合同" class="width100">
          <el-input
            placeholder="请上传合同附件"
            v-model="filename"
            class="width100"
            maxlength="0"
          >
            <template slot="append">
              <el-upload
                class="avatar-uploader"
                :action="Apisrc"
                name="images"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleerror"
                :data="user"
                :headers="head"
              >
                上传
              </el-upload></template
            >
          </el-input>
        </el-form-item>
        <el-form-item label="合同金额(万元)" class="width100">
          <el-input
            placeholder="请输入合同金额(万元)"
            v-model="form.amount"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="合作方名称" class="width100">
          <el-input
            placeholder="请输入合作方名称"
            v-model="form.parter"
            class="width100"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" class="width100">
          <el-input
            placeholder="备注"
            v-model="form.remark"
            class="width100"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="textalign-right">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button
          class="margin-top10"
          type="primary"
          @click="toproductmanagement()"
        >
          保 存
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import { entcontractupdate, entcontractdetail } from "@/api/Center/Center.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      user: {
        // images: "",
      },
      Apisrc: "",
      form: {
        title: "",
        parter: "",
        amount: "",
        write_date: "",
        remark: "",
      },
      file: "",
      filename: "",
    };
  },
  methods: {
    // 上传
    handleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.file = response.data.url;
        this.filename = file[0].name;
      }
    },
    handleerror(err, file, fileList) {
      let error = err;
      this.$message({
        showClose: true,
        message: error,
        type: "error",
      });
    },
    toproductmanagement() {
      if (this.filename == "") {
        (this.errormessage = "请上传附件"), (this.dialogVisiblenull = true);
      } else {
        entcontractupdate({
          id: window.sessionStorage.getItem("Enterprisemodification"),
          title: this.form.title,
          parter: this.form.parter,
          amount: this.form.amount,
          cate_id: this.form.cate_id,
          write_date: this.form.write_date,
          file: this.file,
          remark: this.form.remark,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            BUS.$emit("enterpriseaddfication", "yes");
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    dialognull() {
      BUS.$emit("enterpriseaddfication", "yess");
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/oss_form";

    entcontractdetail({
      id: window.sessionStorage.getItem("Enterprisemodification"),
    }).then((res) => {
      if (res.data.code == 200) {
        this.form.title = res.data.data.title;
        this.form.parter = res.data.data.parter;
        this.form.amount = res.data.data.amount;
        this.form.cate_id = res.data.data.cate_id;
        this.form.write_date = res.data.data.write_date;
        this.file = res.data.data.file;
        this.filename = res.data.data.file;
        this.form.remark = res.data.data.remark;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("Enterprisemodification", (data) => {
      entcontractdetail({
        id: data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.form.title = res.data.data.title;
          this.form.parter = res.data.data.parter;
          this.form.amount = res.data.data.amount;
          this.form.cate_id = res.data.data.cate_id;
          this.form.write_date = res.data.data.write_date;
          this.file = res.data.data.file;
          this.filename = res.data.data.file;
          this.form.remark = res.data.data.remark;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
<style scoped>
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>